import React from 'react'
import { withIcon } from '../../withIcon'

function InfoCircledIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M12 3.625C7.37462 3.625 3.625 7.37462 3.625 12C3.625 16.6254 7.37462 20.375 12 20.375C16.6254 20.375 20.375 16.6254 20.375 12C20.375 7.37462 16.6254 3.625 12 3.625ZM2.375 12C2.375 6.68426 6.68426 2.375 12 2.375C17.3157 2.375 21.625 6.68426 21.625 12C21.625 17.3157 17.3157 21.625 12 21.625C6.68426 21.625 2.375 17.3157 2.375 12ZM11.375 8C11.375 7.65482 11.6548 7.375 12 7.375H12.01C12.3552 7.375 12.635 7.65482 12.635 8C12.635 8.34518 12.3552 8.625 12.01 8.625H12C11.6548 8.625 11.375 8.34518 11.375 8ZM10.375 12C10.375 11.6548 10.6548 11.375 11 11.375H12C12.3452 11.375 12.625 11.6548 12.625 12V15.375H13C13.3452 15.375 13.625 15.6548 13.625 16C13.625 16.3452 13.3452 16.625 13 16.625H12C11.6548 16.625 11.375 16.3452 11.375 16V12.625H11C10.6548 12.625 10.375 12.3452 10.375 12Z" fill={color}/>
    </svg>
  )
}

export default withIcon(InfoCircledIcon)
